import React, { FC, Fragment } from 'react';
import { Waypoint } from 'react-waypoint';
import { useHistory } from 'react-router-dom';
import { ROUTE_FEEDS_BY_TOPIC, ROUTE_FEEDS_BY_TYPE } from 'routes';

import { useGetChannelsSections } from 'graphQL/channel/hooks';
import { ChannelSectionTypeOptions } from 'constants/graphqlTypes';

import useTheme from 'helpers/useTheme';
import { useRefreshDetection } from 'helpers/useRefreshDetection';

import LoaderContent from 'components/UI/LoaderContent';
import Loader from 'components/UI/Loader';
import CustomFeedSection from 'components/Explore/ChannelsTab/CustomFeedSection';
import AdminFeedsSection from './AdminFeedsSection';
import ListSection from './ListSection';
import FeaturedSparksSection from './FeaturedSparksSection';

import { StyledRefreshLoader } from './styled';

const { FollowList, CustomFeeds, AdminFollowByTopic, AdminFollowByType, TrendingList } = ChannelSectionTypeOptions;

const ChannelsTab: FC = () => {
  const { sections, loading, loadMore } = useGetChannelsSections();
  const { push } = useHistory();
  const isDark = useTheme();
  const { shouldShow, isRefreshing } = useRefreshDetection('Channels', loading);
  const orderMap: Record<string, number> = {
    [TrendingList]: 0,
    [AdminFollowByType]: 2,
    [AdminFollowByTopic]: 3,
    [CustomFeeds]: 4,
    [FollowList]: 5,
  };
  const orderedSections = sections?.slice().sort((a, b) => {
    const aPriority = orderMap[String(a.sectionType)] ?? 99;
    const bPriority = orderMap[String(b.sectionType)] ?? 99;
    return aPriority - bPriority;
  });

  return (
    <>
      <StyledRefreshLoader isRefreshing={isRefreshing}>
        <Loader isDark={isDark} size={32} />
      </StyledRefreshLoader>
      {/* <StyledHeaderWrap shouldShow={shouldShow}>
        <TypeAnimation
          preRenderFirstString
          wrapper="p"
          cursor={false}
          sequence={['', 200, 'Diverse ways to explore', 2000]}
          speed={65}
        />
      </StyledHeaderWrap> */}
      {orderedSections?.map((section, index) => (
        <Fragment key={section.id}>
          {section.sectionType === TrendingList && (
            <ListSection section={section} feedTitle="Featured List" feedDescription="Hot & Trending 💥" />
          )}
          {index === 1 && <FeaturedSparksSection />}
          {section.sectionType === AdminFollowByType && (
            <AdminFeedsSection
              handler={() => push(ROUTE_FEEDS_BY_TYPE)}
              section={section}
              feedType="Feeds By Content Type"
              feedDescription="What your friends are listening while cooking ·  Reading on the train · Watching tonight 🧳"
              isDark={isDark}
            />
          )}
          {section.sectionType === AdminFollowByTopic && (
            <AdminFeedsSection
              handler={() => push(ROUTE_FEEDS_BY_TOPIC)}
              section={section}
              feedType="Feeds By Topic"
              feedDescription="The things that fascinate your people 🪩"
              isDark={isDark}
            />
          )}
          {section.sectionType === CustomFeeds && (
            <CustomFeedSection
              section={section}
              feedDescription="Choose ‘What’ you want to see & ‘Who’ you want to see from 🔭"
            />
          )}
          {section.sectionType === FollowList && (
            <ListSection section={section} feedDescription="Tap on the 🔔 in the list to add here" />
          )}
        </Fragment>
      ))}
      {loading ? <LoaderContent isFullScreen={!sections?.length} isDark={isDark} /> : <Waypoint onEnter={loadMore} />}
    </>
  );
};

export default ChannelsTab;
